import { Component } from '@angular/core';
import { ConstantsService } from '../constants.service';

@Component({
  selector: 'app-admin-layout',
  template: require('./admin-layout.component.html'),
  styles: [require('./admin-layout.component.scss')],
})
export class AdminLayoutComponent {
  isCollapsed = true;

  constructor(
    public constants: ConstantsService,
  ) { }

  /**
   * Checks if the user is logged in
   */
  isLoggedIn() {
    if (localStorage.getItem('token')) {
      return true;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/admin/admin-layout/admin-layout.component.ts